exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.template-editor-heading  {\n}\n.template-editor-heading .icon-wrapper {\n    display:inline-block;\n    width:70px;\n    padding:15px;\n    background-color:var(--wf-primary);\n    color:var(--wf-secondary);\n    border-radius : 15px;\n    -moz-border-radius : 15px;\n    -webkit-border-radius : 15px;\n}\n.template-editor-heading h1 {\n  font-size:2.25rem;\n  display:inline-block;\n  color:var(--wf-primary);\n  margin-left:1rem;\n  vertical-align:middle;\n}\n", ""]);

// exports
